const COLS: { title: string; links: string[] }[] = [
  { title: "栏目导航", links: ["今日快讯流", "吃瓜指数榜", "事件档案库", "合集索引"] },
  { title: "热门合集", links: ["人物塌房档案", "综艺名场面", "社媒翻车合集", "年度盘点大会"] },
  { title: "关于本站", links: ["编辑团队", "收录标准", "投稿线索", "商务合作"] },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-300 bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div className="max-w-sm">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-newspaper-line text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black text-foreground-950">嘿料吃瓜</span>
                <span className="mt-1 text-[10px] font-medium tracking-[0.28em] text-primary-600">黑料合集档案库</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              一本关于热闹与门道的线上档案。档案式整理热门事件来龙去脉，把八卦讲完整，也把热度看冷静。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-douban-line", "ri-bilibili-line", "ri-wechat-2-line", "ri-youtube-line"].map((ic) => (
                <a
                  key={ic}
                  href="#"
                  aria-label="关注我们"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  <i className={`${ic} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((c) => (
            <div key={c.title}>
              <h4 className="font-heading text-sm font-black text-foreground-900">{c.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {c.links.map((l) => (
                  <li key={l}>
                    <a href="#" className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-lg border border-background-300 bg-background-100 p-4">
          <p className="text-xs leading-relaxed text-foreground-500">
            内容说明：本站以「公开信息整理 + 内容创作复盘」方式归档网络热点，涉及人物均以公众形象或角色代称呈现，不发布未经证实的内幕，不对任何个人作出事实性负面结论，亦不构成任何立场表达。拒绝造谣、拒绝网暴，理性吃瓜。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 嘿料吃瓜 · 黑料合集档案库 版权所有</p>
          <p className="inline-flex items-center gap-2">
            嘿料吃瓜盘点 / 嘿料吃瓜合集 / 嘿料吃瓜档案
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-leaf-line text-primary-500" />
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}